import { useEffect, useRef, useState } from "react";
import PlaceholderImageAlt from "../atoms/PlaceholderImageAlt";
import InputWrap from "./InputWrap";
import css from "./NameAvatar.module.scss";

export default function NameAvatar({
    src = null,
    name,
    firstName,
    lastName,
    setNames,
    size,
    showEdit,
}) {
    return (
        <div className={css["avatar"]}>
            <div
                className={css["image-container"]}
                style={{ width: size, height: size }}
            >
                <PlaceholderImageAlt
                    size={size}
                    type="circle"
                    iconUnicode=""
                />

                {showEdit && (
                    <button className={css["edit-button"]}>
                        <i className="fal fa-camera" />
                    </button>
                )}
            </div>

            <div className={css["names"]}>
                <InputWrap
                    label="First Name"
                    component={<input value={firstName}></input>}
                />
                <InputWrap
                    label="Last Name"
                    component={<input value={lastName}></input>}
                />
            </div>
        </div>
    );
}
